module.exports = __webpack_public_path__ + "static/media/IMG_0533.c255a46e.jpg";